import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import AdditionalServiceDiscountVoucherContainer from 'app/containers/Marketing/VoucherManagement/AdditionalServiceVoucher'

const AdditionalServiceDiscountVoucherPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.additional_service)}</PageTitle>
      <AdditionalServiceDiscountVoucherContainer />
    </>
  )
}
const AdditionalServiceDiscountVoucherPage = memo(
  AdditionalServiceDiscountVoucherPageCpn,
  isEqual,
)

export default AdditionalServiceDiscountVoucherPage
